import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_close.svg'


const _hoisted_1 = { class: "flex flex-col gap-2 px-4 py-2 rounded-xl bg-white" }
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = { class: "flex gap-x-1 items-center" }
const _hoisted_4 = {
  key: 0,
  class: "text-red-lp-2000 text-sm"
}
const _hoisted_5 = {
  key: 0,
  "data-testid": "cargo-v2-manual-input-error-nog",
  class: "text-red-lp-2000 text-sm"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_InputVehicleNo = _resolveComponent("InputVehicleNo")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Select = _resolveComponent("Select")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_CargoV2PlaneTrack = _resolveComponent("CargoV2PlaneTrack")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (!_ctx.isTruck)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 0,
            label: _ctx.$t('cargoV2.components.manualInput.cargoNumberManual'),
            optional: _ctx.isPlane,
            tooltipDescription: _ctx.cargoNumberTooltip,
            class: `${_ctx.isPlane && !_ctx.isEdit ? 'w-1/3' : 'flex-1'}`
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode("div", {
                  class: ["w-full flex flex-row flex-nowrap relative border rounded-md text-black-lp-300 py-3 px-4 items-center gap-2", 
              `${
                _ctx.form.isErroAwb ? 'border-red-lp-2000' : 'border-gray-lp-2100'
              } ${_ctx.emptyTransport || _ctx.isEdit ? 'bg-gray-lp-1500' : 'bg-white'}`
            ]
                }, [
                  (_ctx.iconCargoNumber)
                    ? (_openBlock(), _createBlock("img", {
                        key: 0,
                        src: require(`@/app/ui/assets/svg/${_ctx.iconCargoNumber}.svg`),
                        class: "w-5 h-5 max-w-none",
                        alt: "icon-cargo-number"
                      }, null, 8, ["src"]))
                    : _createCommentVNode("", true),
                  _createVNode("input", {
                    value: _ctx.form.cargoNo,
                    onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChangeCargoNumber && _ctx.onChangeCargoNumber(...args))),
                    placeholder: 
                _ctx.$t('cargoV2.components.manualInput.inputCargoNumberManual')
              ,
                    class: ["flex-shrink bg-white rounded-md leading-tight font-normal focus:outline-none text-black-lp-300 w-full", 
                `${_ctx.emptyTransport || _ctx.isEdit ? 'bg-gray-lp-1500' : 'bg-white'}`
              ],
                    autocomplete: "nope",
                    disabled: _ctx.emptyTransport || _ctx.isEdit
                  }, null, 42, ["value", "placeholder", "disabled"]),
                  (_ctx.form.cargoNo && !_ctx.isEdit)
                    ? (_openBlock(), _createBlock("div", {
                        key: 1,
                        "data-testid": "cargo-v2-manual-input-clear-cargo-no",
                        class: "absolute inset-y-0 right-0 mr-2 items-center px-2 py-3",
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onClear && _ctx.onClear(...args)))
                      }, [
                        _createVNode("img", {
                          src: _imports_0,
                          alt: _ctx.$t('cargoV2.components.common.closeAlt')
                        }, null, 8, ["alt"])
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (_ctx.isPlane && !_ctx.isEdit)
                  ? (_openBlock(), _createBlock(_component_LpButton, {
                      key: 0,
                      "data-testid": "cargo-v2-manual-input-button-track-awb",
                      onClick: _ctx.onCheckAwb,
                      customClass: "px-3 py-2.5",
                      title: _ctx.$t('cargoV2.components.manualInput.track'),
                      textColor: "white",
                      disabled: !_ctx.form.cargoNo
                    }, null, 8, ["onClick", "title", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.form.isErroAwb)
                ? (_openBlock(), _createBlock("div", _hoisted_4, _toDisplayString(_ctx.errorAwb), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label", "optional", "tooltipDescription", "class"]))
        : _createCommentVNode("", true),
      (!_ctx.isPlane && !_ctx.emptyTransport)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 1,
            class: "flex-1",
            label: _ctx.$t('cargoV2.components.common.vehicleSerialNumber')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_SelectSearch, {
                "is-loading": _ctx.loadingDriver,
                options: _ctx.listVehicleNumber,
                onFocus: _ctx.fetchDrivers,
                onFilter: _ctx.fetchDrivers,
                modelValue: _ctx.driverItem,
                "onUpdate:modelValue": [
                  _cache[3] || (_cache[3] = ($event: any) => (_ctx.driverItem = $event)),
                  _ctx.onSelectDriver
                ],
                placeholder: 
            _ctx.$t('cargoV2.components.common.searchVehicleSerialNumber')
          ,
                serverSide: false,
                class: "w-full",
                keyName: "label",
                keyValue: "value",
                customClassInput: "h-10",
                isDisabled: _ctx.isEdit,
                disabledBackground: _ctx.isEdit
              }, null, 8, ["is-loading", "options", "onFocus", "onFilter", "modelValue", "onUpdate:modelValue", "placeholder", "isDisabled", "disabledBackground"])
            ]),
            _: 1
          }, 8, ["label"]))
        : _createCommentVNode("", true),
      (_ctx.form.driverSelected === 'other')
        ? (_openBlock(), _createBlock(_component_InputVehicleNo, {
            key: 2,
            class: "flex-1",
            modelValue: _ctx.form.cargoVehicleNo,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.cargoVehicleNo = $event)),
            "is-valid": _ctx.form.isValidVehicleNo,
            "onUpdate:is-valid": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.isValidVehicleNo = $event)),
            isEdit: _ctx.isEdit,
            marginVertical: ""
          }, null, 8, ["modelValue", "is-valid", "isEdit"]))
        : _createCommentVNode("", true),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('cargoV2.components.common.commodity'),
        class: "flex-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_CustomDropdown, {
            class: "w-full",
            placeholder: _ctx.$t('cargoV2.components.common.selectCommodity'),
            options: _ctx.commodityOptions,
            onSelect: _ctx.onSelectCommodity,
            selectedItem: _ctx.form.cargoCommodity,
            isCustomWidth: "",
            isDisabled: 
            _ctx.emptyTransport || _ctx.commodityOptions.length === 1 || _ctx.isEdit
          ,
            disableBackground: 
            _ctx.emptyTransport || _ctx.commodityOptions.length === 1 || _ctx.isEdit
          
          }, null, 8, ["placeholder", "options", "onSelect", "selectedItem", "isDisabled", "disableBackground"])
        ]),
        _: 1
      }, 8, ["label"]),
      _createVNode(_component_DataWrapper, {
        label: _ctx.$t('cargoV2.components.common.product'),
        class: "flex-1"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Select, {
            onOpenSelect: _ctx.onOpenSelectCargoProduct,
            onCloseSelect: _ctx.onCloseSelectCargoProduct,
            isOpenMenu: _ctx.isOpenSelectCargoProduct,
            value: _ctx.form.productCargo,
            onChooseSelect: _ctx.onSelectCargoProduct,
            dataSelect: _ctx.listProductCargo,
            customClass: "w-full",
            class: "w-full whitespace-no-wrap z-10",
            isDisabled: _ctx.emptyTransport || _ctx.isEdit,
            disabledBackground: _ctx.emptyTransport || _ctx.isEdit
          }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect", "isDisabled", "disabledBackground"])
        ]),
        _: 1
      }, 8, ["label"]),
      (_ctx.isPlane)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 3,
            label: _ctx.$t('cargoV2.components.common.nog'),
            class: "flex-1",
            tooltipDescription: _ctx.$t('cargoV2.components.common.nogTooltip')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_LpInput, {
                "data-testid": "cargo-v2-manual-input-nog",
                onChange: _ctx.onChangeNog,
                modelValue: _ctx.form.nog,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.nog = $event)),
                placeholder: _ctx.$t('cargoV2.components.common.inputNog'),
                marginVertical: "",
                disabled: _ctx.isEdit,
                disableBackground: _ctx.isEdit,
                error: _ctx.isNogErrorVisible,
                isErrorIconCaption: false
              }, null, 8, ["onChange", "modelValue", "placeholder", "disabled", "disableBackground", "error"]),
              (_ctx.isNogErrorVisible)
                ? (_openBlock(), _createBlock("div", _hoisted_5, _toDisplayString(_ctx.$t("cargo.v2.nog.error.required")), 1))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["label", "tooltipDescription"]))
        : _createCommentVNode("", true),
      (_ctx.isPlane)
        ? (_openBlock(), _createBlock(_component_DataWrapper, {
            key: 4,
            label: _ctx.$t('cargoV2.components.common.shc'),
            optional: "",
            class: "flex-1",
            tooltipDescription: _ctx.$t('cargoV2.components.common.shcTooltip')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_CustomDropdown, {
                class: "w-full",
                placeholder: _ctx.$t('cargoV2.components.common.selectShc'),
                options: _ctx.listShc,
                onSelect: _ctx.onSelectShc,
                selectedItem: _ctx.shcItem,
                isCustomWidth: "",
                isDisabled: _ctx.listShc.length === 1 || _ctx.isEdit,
                disableBackground: _ctx.listShc.length === 1 || _ctx.isEdit
              }, null, 8, ["placeholder", "options", "onSelect", "selectedItem", "isDisabled", "disableBackground"])
            ]),
            _: 1
          }, 8, ["label", "tooltipDescription"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.flightData.itineraries.length)
      ? (_openBlock(), _createBlock(_component_CargoV2PlaneTrack, {
          key: 0,
          data: _ctx.flightData
        }, null, 8, ["data"]))
      : _createCommentVNode("", true)
  ]))
}